module.exports = __webpack_public_path__ + "img/21_112.6926de42.png";